<template>
  <Teleport to="#menu-container" defer>
    <div
      name="snack"
      class="fixed left-1/2 w-full max-w-sm -translate-x-1/2 space-y-2 px-4 z-200 bottom-0"
    >
      <transition-group
        enter-from-class="opacity-0 translate-y-full"
        enter-active-class="duration-500"
        leave-active-class="duration-500"
        enter-to-class="opacity-100 translate-y-0"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0"
      >
        <BaseSnackItem
          v-for="snack in snackStore.snacks"
          :key="snack.id"
          :message="snack"
          :position="getIndexOf(snack)"
          @click="() => snackStore.dismiss(snack.id)"
        />
      </transition-group>
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
import BaseSnackItem from './BaseSnackItem.vue'
import { useSnackStore } from '../../../../stores/snack.store'
import type { SnackMessage } from '../../../models/snack'

const snackStore = useSnackStore()

const getIndexOf = (message: SnackMessage) => {
  return snackStore.snacks.indexOf(message)
}
</script>
